import { useProfile } from '@hooks/api';
import { useLoadingModal } from '@hooks/useLoadingModal';
import DesktopNavBar from './DesktopNavBar';
import MobileNavBar from './MobileNavBar';

const NavBar = () => {
    const { isLoading, isError } = useProfile();

    useLoadingModal(isLoading);

    if (isError) {
        return <></>;
    }
    return (
        <div className="flex w-full flex-col">
            <DesktopNavBar />
            <div className="flex lg:hidden">
                <MobileNavBar />
            </div>
        </div>
    );
};

export default NavBar;
